/* ============================================================
   Recherche v2 — mise en évidence des termes recherchés.

   L'API Google renvoie déjà ses correspondances balisées en <b>
   (htmlTitle / htmlSnippet). Les résultats typés (POI, agenda,
   actualités, presse) viennent du CMS sans balisage : on surligne
   côté client les éléments portant [data-search-highlight].

   Le remplacement se fait sur les nœuds texte uniquement : aucun
   HTML n'est réinjecté, donc pas de risque d'injection.
   ============================================================ */

function collectTextNodes(root) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) {
    nodes.push(walker.currentNode);
  }
  return nodes;
}

function highlightElement(el, regex) {
  collectTextNodes(el).forEach((node) => {
    const value = node.nodeValue;
    if (!value || !value.trim()) return;

    regex.lastIndex = 0;
    if (!regex.test(value)) return;

    regex.lastIndex = 0;
    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    let match;

    while ((match = regex.exec(value)) !== null) {
      if (match.index > lastIndex) {
        fragment.appendChild(
          document.createTextNode(value.slice(lastIndex, match.index))
        );
      }
      const mark = document.createElement("mark");
      mark.textContent = match[0];
      fragment.appendChild(mark);
      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < value.length) {
      fragment.appendChild(document.createTextNode(value.slice(lastIndex)));
    }

    node.parentNode.replaceChild(fragment, node);
  });
}

function initSearchHighlight() {
  const root = document.querySelector("[data-search-v2]");
  if (!root) return;

  const query = (root.dataset.searchQuery || "").trim();
  if (query.length < 2) return;

  const terms = Array.from(
    new Set(
      query
        .toLowerCase()
        .split(/\s+/)
        .filter((term) => term.length > 1)
    )
  );
  if (!terms.length) return;

  // Les termes les plus longs d'abord, pour surligner « casemates »
  // plutôt que « case » quand les deux sont présents dans la requête.
  terms.sort((a, b) => b.length - a.length);

  const pattern = terms
    .map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
    .join("|");
  const regex = new RegExp("(" + pattern + ")", "gi");

  root
    .querySelectorAll("[data-search-highlight]")
    .forEach((el) => highlightElement(el, regex));
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSearchHighlight);
} else {
  initSearchHighlight();
}
